import { translation_en } from "./english";
import { translation_fr } from "./french";

export const languages:any = { en:translation_en, fr:translation_fr}; 